/** @file The ASCII name pattern for node, drawable, sheet, socket, variant and table names. */

/** Letter or underscore, then letters, digits, `_`, `.` or `-` (no `/` or `:`, which slot keys use). */
export const NAME_PATTERN = /^[A-Za-z_][A-Za-z0-9_.-]*$/;
